import { BookingRejectedError } from './BookingRejectedError';

export class MaxWeekdayBookingsReachedError extends BookingRejectedError {
    constructor() {
        super('Alcanzaste el máximo de reservas permitidas para días de semana.');
    }
}
